import { ref, watch } from 'vue';
import { useMenuStore } from '@/stores/menu';
import { useUserStore } from '@/stores/user';

export function useMenuInit(isAuthenticated) {
    const menuStore = useMenuStore();
    const userStore = useUserStore();

    const menu             = ref([]);
    const type_menu        = ref('admin');
    const show_publications = ref(false);

    // Rehidratar menú al iniciar si hay sesión activa
    const initMenu = () => {
        if (isAuthenticated.value && menuStore.menu?.length) {
            menuStore.setDynamicRoutes();
            menu.value      = menuStore.menu;
            type_menu.value = menuStore.type_menu;
        }

        // Rehidratar sucursal_sponsored desde localStorage
        const raw = localStorage.getItem('sucursal_sponsored');
        if (raw) {
            const parsed = JSON.parse(raw);
            userStore.setInforSucursalSponsored(parsed);
        }
    };

    watch(() => menuStore.menu,      (val) => menu.value      = val);
    watch(() => menuStore.type_menu, (val) => type_menu.value = val);

    watch(() => userStore.sucursal_sponsored, (val) => {
        show_publications.value = !!val?.is_sponsored;
    });

    return { menu, type_menu, show_publications, menuStore, initMenu };
}